import React, { useCallback } from 'react';
import debounce from 'lodash/debounce';
import { MultiRadioSwitch, MultiRadioWithLabelLi } from './multi-radio-with-label.style';
import HighlightSearchMatch from '../highlight-search-match/highlight-search-match';

interface Props {
    id: string;
    label: string;
    listName: string;
    searchTerm: string;
    onToggle: () => void;
    checked?: boolean;
}

const MultiRadioWithLabel: React.FC<Props> = ({
    id,
    label,
    listName,
    searchTerm,
    onToggle,
    checked = false
}) => {
    const debouncedToggle = useCallback(
        debounce(() => {
            onToggle();
        }, 300),
        [onToggle]
    );

    const handleClick = () => {
        debouncedToggle();
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if (e.key === ' ' || e.key === 'Enter') {
            e.preventDefault();
            debouncedToggle();
        }
    };

    return (
        <MultiRadioWithLabelLi 
            key={id} 
            role="radio"
            aria-checked={checked}
            onClick={handleClick}
            onKeyDown={handleKeyDown}
            tabIndex={0}
        >
            <MultiRadioSwitch
                type="radio"
                id={id}
                name={listName}
                checked={checked}
                tabIndex={-1}
                aria-hidden="true"
                aria-labelledby={`${id}-label`}
                aria-checked={checked}
            />
            <label htmlFor={id} id={`${id}-label`}>
                {searchTerm ? (
                    <HighlightSearchMatch label={label} searchTerm={searchTerm} />
                ) : (
                    label
                )}
            </label>
        </MultiRadioWithLabelLi>
    );
};

export default MultiRadioWithLabel;
